import styled from 'styled-components';

export const BorderlessIframe = styled.iframe`
  border: none;
`;

// Maintains a consistent aspect ratio.
// This is calculated based on the paddingBottom prop
// 56.25% is 16:9

export const ResponsiveIframeWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100px;
  padding-bottom: ${(props) =>
    props.paddingBottom ? `${props.paddingBottom}%` : '56.25%'};
  margin-bottom: ${(props) => props.theme.spacing.standard};

  iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
`;
